import wrapperRequest from '@/utils/request';

export interface NotificationItem {
  id: number;
  portalId: number;
  ownerId: number;
  event: string;
  subject: string;
  description: string;
  payload: string;
  notifiedAt: string;
  createdAt: string;
  status: number;
  notifyType: number;
  eventId: string;
}

export interface NotificationListParams {
  pageIndex?: number;
  pageSize?: number;
  keyword?: string;
  isRead?: number | null;
  isMark?: number | null;
  fromDate?: string;
  toDate?: string;
  pageSorts?: any;
}

export interface NotificationListResponse {
  total: number;
  pageSize: number;
  pageIndex: number;
  list: NotificationItem[];
}

export async function getNotificationList(body: NotificationListParams) {
  const res = await wrapperRequest<{
    status: number;
    message: string;
    data: NotificationListResponse;
    success: boolean;
  }>('/erpanlam-hrm/notification/mine/list', {
    method: 'POST',
    data: body,
  });
  return {
    data: res?.data?.list ?? [],
    total: res?.data?.total ?? 0,
    pageSize: res?.data?.pageSize ?? 0,
    pageIndex: res?.data?.pageIndex ?? 0,
    success: res?.success ?? false,
    message: res?.message ?? '',
  };
}

export async function markNotificationAsRead(id: number) {
  const res = await wrapperRequest<{
    status: number;
    message: string;
    success: boolean;
  }>(`/erpanlam-hrm/notification/mine/read/${id}`, {
    method: 'GET',
  });
  return {
    success: res?.success ?? false,
    message: res?.message ?? '',
  };
}
